import type { ServiceLabel } from './types';

export const USA_SERVICES: readonly ServiceLabel[] = [
  { key: 'Federal Tax Return',   label: 'Federal Tax Return',   jurisdiction: 'USA' },
  { key: 'State Tax Return',      label: 'State Tax Return',     jurisdiction: 'USA' },
  { key: 'Annual Report',         label: 'Annual Report',        jurisdiction: 'USA' },
  { key: 'Payroll',               label: 'Payroll',              jurisdiction: 'USA' },
  { key: 'Bookkeeping',           label: 'Bookkeeping',          jurisdiction: 'USA' },
  { key: 'EIN Registration',      label: 'EIN Registration',     jurisdiction: 'USA' },
  { key: 'IRS Returns',           label: 'Federal Tax Returns (IRS)', jurisdiction: 'USA' },
  { key: 'State Returns',         label: 'State Tax Returns',    jurisdiction: 'USA' },
  { key: 'Sales Tax Registration', label: 'Sales Tax Registration', jurisdiction: 'USA' },
  { key: 'W2 1099',               label: 'Payroll W-2 1099, 1099-Misc, 1099-NEI', jurisdiction: 'USA' },
  { key: 'Annual State Reports',  label: 'Annual State Reports', jurisdiction: 'USA' },
  { key: 'Registered Agent',      label: 'Registered Agent Compliance', jurisdiction: 'USA' },
  { key: 'BOI',                   label: 'BOI Reporting (subject to current requirements)', jurisdiction: 'USA' },
  { key: 'Personal Tax',          label: 'Personal Tax Returns (1040)', jurisdiction: 'USA' },
  { key: 'Other',                 label: 'Other',                jurisdiction: 'USA' },
] as const;